import AnalyticsHelper from '../../utils/analytics-helper';
import SaveConfiguration from '../saved_configuration/save-configuration';
import Flyout from './flyout';
import Login from './login';
import Mask from './mask';
import myAccount from './my-account';
import Search from './search';

export default class Navigation {
    constructor(el) {
        this.el = el;
        this.html = document.querySelector('html');
        this.body = document.querySelector('body');
        this.navGlobal = el.querySelector('.nav__global');
        this.navPrimary = el.querySelector('.nav__primary');
        this.toggle = el.querySelector('.nav__toggle');
        this.container = document.querySelector('.responsive-nav');
        this.navList = document.querySelectorAll('.more-button');
        this.leftSide = document.querySelector('.left-nav-desktop');
        this.rightSide = document.querySelector('.right-nav-items');
        this.stickyNav = document.querySelector('.sticky-navbar-mobile');
        this.isAem = document.querySelector('.aem-AuthorLayer-Edit');
        this.showSticky = document.querySelector('.show-sticky');
        this.savedItemCountEle = document.querySelectorAll('.saved-item-count');
        this.mask = new Mask(this);
        this.search = new Search(this);
        this.flyouts = [...el.querySelectorAll('nav > ul > li')]
            .filter((ele) => ele.querySelector('.link--primary'))
            .map((t) => new Flyout(this, t));
        this.featuresMenu = document.querySelector('.features-menu');
        this.login = new Login(this);
        this.myAccount = new myAccount();

        this.bind();
    }

    bind() {
        this.mobileToggle();
        this.updateNavGlobalPosition();
        this.windowResize();
        this.showSecondaryNav();
        this.navToggle();
        this.stickyOnScroll();
        this.el.addEventListener('keydown', (event) => this.navigationOnKeydown(event));
        this.el.addEventListener('focusout', (event) => this.navigationFocusout(event));
        SaveConfiguration.updateSavedCountInNavigation();
    }

    close() {
        this.flyouts.forEach((f) => f.close());
        this.update();
    }

    update() {
        if (window.innerWidth > 1024) {
            this.body.style.height = '';
        }
    }

    mobileToggle() {
        this.toggle?.addEventListener('click', (e) => {
            e.preventDefault();
            const isOpen = this.el.classList.contains('open');

            isOpen && this.close();
            this.el.classList.toggle('open', !isOpen);
            this.toggle.setAttribute('aria-expanded', !isOpen);

            AnalyticsHelper.push(this.toggle);
        });
    }

    navigationOnKeydown(event) {
        if (event && event.key === 'Escape') {
            event.stopPropagation();
            this.close();
            this.el.classList.remove('open');
            this.toggle?.setAttribute('aria-expanded', 'false');
            this.toggle?.focus();
        }
    }

    navigationFocusout(event) {
        if (event && event.relatedTarget && !this.el.contains(event.relatedTarget)) {
            this.close();
            this.el.classList.remove('open');
            this.toggle?.setAttribute('aria-expanded', 'false');
        }
    }

    resize(flyoutHeight) {
        const pageHeight = document.documentElement.clientHeight;
        const navHeight = this.el.clientHeight + flyoutHeight;
        if (window.innerWidth > 1024 && navHeight > pageHeight) {
            this.body.style.height = `${navHeight}px`;
        }
    }

    updateNavGlobalPosition() {
        if (window.innerWidth > 1024) {
            // Move navGlobal before navPrimary for mobile view
            if (this.navGlobal && this.navPrimary && this.navPrimary.previousElementSibling !== this.navGlobal) {
                this.el.insertBefore(this.navGlobal, this.navPrimary);
            }
        } else {
            // Move navPrimary before navGlobal for desktop view
            if (this.navGlobal && this.navPrimary && this.navGlobal.previousElementSibling !== this.navPrimary) {
                this.el.insertBefore(this.navPrimary, this.navGlobal);
            }
        }
    }

    windowResize() {
        window.addEventListener('resize', () => {
            if (!this.isAem) {
                this.updateNavGlobalPosition();
                this.checkOverlap();
            }
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
                this.flyouts.forEach((f) => f.windowResize());
                this.update();
            }, 250);
        });
    }

    showSecondaryNav() {
        if (this.container) {
            this.container.classList.add('show-navigation');
        }

        // For Author Mode
        if (!this.isAem) {
            this.checkOverlap();
        }
    }

    stickyOnScroll() {
        if (this.showSticky) {
            window.addEventListener('scroll', () => {
                const currentScroll = window.scrollY;
                const headerHeight = this.container.offsetHeight;
                if (currentScroll > headerHeight + 100) {
                    this.container.classList.add('is-sticky');
                    this.featuresMenu?.classList.add('with-sticky');
                    this.body.querySelector('.mobile-menu-wrapper')?.classList.add('mobile-sticky');
                } else {
                    this.container.classList.remove('is-sticky');
                    this.featuresMenu?.classList.remove('with-sticky');
                    this.body.querySelector('.mobile-menu-wrapper')?.classList.remove('mobile-sticky');
                }
            });
        }
    }

    checkOverlap() {
        const leftRect = this.leftSide?.getBoundingClientRect() ?? null;
        const rightRect = this.rightSide?.getBoundingClientRect() ?? null;

        if (leftRect && rightRect) {
            if (leftRect.right + 50 >= rightRect.left) {
                this.container.classList.add('show-mobile-view');
                this.stickyNav.classList.add('show-sticky-nav');
            } else {
                this.container.classList.remove('show-mobile-view');
                this.stickyNav.classList.remove('show-sticky-nav');
            }
        }
    }


    navToggle() {
        this.navList.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                this.navItems = item.parentNode.querySelector('.dropdown-items');
                if (item.classList.contains('active')) {
                    item.classList.remove('active');
                    this.navItems.classList.remove('open');
                } else {
                    item.classList.add('active');
                    this.navItems.classList.add('open');
                }
            });
        });
    }
}

if (document.querySelector('header.nav')) {
    const navigation = new Navigation(document.querySelector('header.nav'));
}
